module.exports = __webpack_public_path__ + "static/media/BG_right.d3d8c1ef.png";